import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=88a64e64&scoped=true&"
import script from "./accountSettings.vue?vue&type=script&lang=ts&"
export * from "./accountSettings.vue?vue&type=script&lang=ts&"
import style0 from "./accountSettings.vue?vue&type=style&index=0&id=88a64e64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a64e64",
  null
  
)

export default component.exports